import { render, staticRenderFns } from "./ActivityDetailsAppointment.vue?vue&type=template&id=08368566&"
import script from "./ActivityDetailsAppointment.vue?vue&type=script&lang=js&"
export * from "./ActivityDetailsAppointment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports